<template>
	<div class="file-upload">
		<Uploader v-model="fileList" :max-count="maxCount" preview-size="63px" result-type="file" :max-size="maxSize" :upload-icon="require('../../assets/img-v2/ic_feedback_uploader.png')" @oversize="onOversize" :after-read="onAfterRead"/>
	</div>
</template>

<script>
import { Uploader } from 'vant';
import upload from "../../utils/upload";

export default {
	name: 'FileUpload',
	components: {Uploader},
	model: {
		prop: 'list',
		event: 'change'
	},
	props: {
		list: {
			type: Array,
			default() {
				return [];
			}
		},
		maxCount: {
			type: Number,
			default: 4
		},
		maxSize: {
			type: Number,
			default: 1024 * 1024 * 20 // 20M
		}
	},
	data() {
		return {
			fileList: []
		};
	},
	computed: {
		count() {
			return this.list.length;
		}
	},
	watch: {
		fileList: {
			immediate: false,
			handler(list) {
				this.$emit('change', list);
			}
		},
	},
	methods: {
		onOversize() {
			this.$toast('图片过大');
		},
		onAfterRead(obj, detail) {
			obj.status = 'uploading';
			obj.message = '上传中...';
			let fd = new FormData();
			fd.append('file', obj.file);
			upload.post('/feedback/uploadImage', fd).then((res) => {
				let [url] = res || [];
				let list = this.fileList;
				list[detail.index].url = url;
				this.fileList = [...list];
				obj.status = 'success';
				obj.message = '上传成功';
			}).catch((res) => {
				console.log('upload fail', res);
				obj.status = 'failed';
				obj.message = '上传失败';
			});
		}
	}
};
</script>

<style scoped lang="scss">
	.file-upload {
		padding: 12px 20px 0 20px;
	}
</style>
